var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');

require('./Service.less');

var Closed = require('submissions/components/Closed/Closed');
var Login = require('submissions/components/Login/Login');
var CreateAccount = require('submissions/components/CreateAccount/CreateAccount');
var Forgot = require('submissions/components/Forgot/Forgot');
var Reset = require('submissions/components/Reset/Reset');


module.exports = Section.extend({

    el: '.Service',

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        this.isNewLogin = false;
        this.lastEmail = '';

        app.vent.trigger('hide-sidebar');
        app.vent.trigger('hide-footer');

        this.update(this, options);

        Section.prototype.initialize.call(this, options);
    },


    showView: function (view, params) {
        params = params || {};

        this.prevView && this.prevView.hide();

        view.show(params);

        this.prevView = view;
    },


    //on update without reload
    update: function (view, params) {

        if (params.viewData.state == 'closed') {
            this.closed = this.closed || new Closed({});
            this.showView(this.closed);
        }

        if (params.viewData.state == 'reset') {
            this.reset = this.reset || new Reset({});
            this.showView(this.reset);
        }

        if (params.viewData.state == 'login') {
            if (!this.login) {
                this.login = new Login({});
                this.login.on('forgot-email', function (email) {
                    this.lastEmail = email;
                }.bind(this));
            }

            this.showView(this.login, {
                isNew: this.isNewLogin,
                email: this.lastEmail
            });
        }

        if (params.viewData.state == 'create') {
            if (!this.create) {
                this.create = new CreateAccount({});
                this.create.on('login-email', function (email) {
                    this.lastEmail = email;
                    this.isNewLogin = true;
                }.bind(this));
            }

            this.showView(this.create);
        }

        if (params.viewData.state == 'forgot') {
            this.forgot = this.forgot || new Forgot({});
            this.showView(this.forgot, {
                email: this.lastEmail
            });
        }

        //no section.update prototype call!
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/Service/Service.js
// module id = 135
// module chunks = 0